import { element, globalEvent } from '@shared/easyfy.core';
import Toggle from '@clientShared/toggle';
import { GetNotifyMeFlyout } from '@clientWebServices/notifyme.service';
import { SALES_UNITS_CLOSE } from '@clientWebModules/salesunitselector';
import MessageService from '@clientWebServices/message.service';

// Matches NotifyMeFlyoutViewModel.FlyoutContainer on the server.
const FLYOUT_SELECTOR = '[data-container="notify-me-flyout"]';

/**
 * Opens the Notify Me flyout for the product whose "Notify me" button was clicked, on product cards and the product page alike.
 * The form inside is posted by the shared haypp-ajax-form handler in form.ts.
 */
export default class NotifyMe {
  static Instance: NotifyMe;

  constructor() {
    NotifyMe.Instance = this;
    globalEvent({
      type: 'click',
      events: [
        {
          action: 'notify-me',
          callback: this.loadNotifyMeFlyout,
        },
      ],
    });
    globalEvent({
      type: 'form-success',
      events: [
        {
          event: 'notify-me-form-success',
          callback: this.onSignupSuccess,
        },
      ],
    });
  }

  private openFlyout(flyout: Element, trigger: HTMLElement) {
    Toggle.Instance.lastTriggerElement = trigger;
    document.body.classList.add('noof', 'overlay-is-active');
    flyout.setAttribute('data-toggle-open', '');
    Toggle.Instance.triggerFlyoutImpression(flyout);
    if (!(flyout instanceof HTMLElement)) return;
    Toggle.Instance.trapFocusInFlyout(flyout);
    Toggle.Instance.moveFocusToElement(flyout);
  }

  loadNotifyMeFlyout = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const closeSalesUnitSelector = new CustomEvent(SALES_UNITS_CLOSE);
    document.dispatchEvent(closeSalesUnitSelector);

    const button = (e.target as HTMLElement)?.closest<HTMLElement>('[data-action="notify-me"]');
    const searchProductId = button?.dataset.searchproductid;

    if (!button || !searchProductId) return false;

    const existingFlyout = element(FLYOUT_SELECTOR);
    if (existingFlyout?.hasAttribute('data-toggle-open')) return false;

    // Always load a fresh flyout: it belongs to one product, and after a signup it holds the success state instead of the form.
    existingFlyout?.remove();

    GetNotifyMeFlyout(searchProductId)
      .then((res) => {
        const partialHtml = res?.data?.success ? res?.data?.partialHtml : null;
        const content = partialHtml ? document.createRange().createContextualFragment(partialHtml).firstElementChild : null;
        if (!content) {
          MessageService.Instance.displayDefaultErrorMessage();
          return;
        }
        document.body.appendChild(content);
        this.openFlyout(content, button);
      })
      .catch((err) => {
        console.log(err);
        MessageService.Instance.displayDefaultErrorMessage();
      });

    return false;
  };

  // form.ts raises form-success just before it swaps the form for the success state, which drops the focus; move it to the new state.
  onSignupSuccess = () => {
    setTimeout(() => element(`${FLYOUT_SELECTOR} [data-container="notify-me-success"]`)?.focus(), 0);
  };
}
